import { DateTime } from "luxon";
import { matchesSunsetPlusTier } from "../domains2/priceRules/priceRulesHelpers";

export const isPlusDiscountBetterThanProductDiscount = ({store, basePrice, discountPrice}) => {
	const priceRule = globalSunsetPlusDiscountRule(store);
	if (!priceRule) return false;
	const {discountMax, discountPct} = priceRule.options;
	const dailySpending = getDailySpending(store);
	const totalRabat = getTotalRabat(store);
	let availablePLUSdiscount = Math.max((discountMax - dailySpending) * discountPct - totalRabat, 0);
	const plusDiscount = basePrice * discountPct;
	availablePLUSdiscount = Math.min(availablePLUSdiscount, plusDiscount);
	const productDiscount = basePrice - discountPrice;
	return availablePLUSdiscount > productDiscount;
};

export function globalSunsetPlusDiscountRule(store) {
	const {subscriptionDetails, productCatalog} = store.getters; 
	if (!subscriptionDetails || !subscriptionDetails.subscriptionPlanName) {
		return null;
	}
	return productCatalog.priceRules.find(
		x => x.discountType === "globalDiscountWithMax" && matchesSunsetPlusTier(x.options, subscriptionDetails.subscriptionPlanName)
	);
}
function getDailySpending(store) {
	const day = DateTime.now().toFormat("yyyy-MM-dd");
	return (((store.getters.applicationUserData || {}).meta || {}).dailySpending || {})[day] || 0;
}
function getTotalRabat(store) {
	return (store.getters.orderLines.find(x=>x.type==="Discount") || {totalPrice: 0}).totalPrice * (-1);
} 
